import { IconCloseCircle } from 'assets/img';
import { useDialog } from 'ogp/providers/dialog-provider';
import { ContextMenuItem } from 'redesign';
import { shiftAlerts, useAlert } from 'shared/components/alerts';
import { useInvalidateQuery } from 'shared/hooks/query-hooks/useInvalidateQuery';
import { useHqCancelShiftClaim } from 'shared/components/shift-detail-modal/query-hooks/hq/use-hq-cancel-shift-claim';
import { WorkerEmploymentType } from '@types';
import { QUERY_KEYS } from 'api/query-keys';
import { getOgpCancelationDialog } from '../../../shared/cancelation-dialog/cancelation-dialog';
import { isWithinCancelationPeriod } from '../../../shared/cancelation-dialog/cancelation-dialog.utils';

export const HQCancelShiftClaimAction = ({
  candidate,
  shiftData,
}: {
  candidate: {
    claimId: string;
    isFlexWorker: boolean;
    employmentType: WorkerEmploymentType | undefined;
  };
  shiftData: { isFreelance: boolean; mutableUntilDate: string; id: string };
}) => {
  const { alertSuccess, alertError } = useAlert();
  const { openDialog, closeDialog, enableDialog, disableDialog } = useDialog();
  const invalidateQuery = useInvalidateQuery();
  const cancelShiftClaim = useHqCancelShiftClaim();

  const handleCancelShiftClaim = async (
    shiftData: { isFreelance: boolean; mutableUntilDate: string; id: string },
    candidate: {
      claimId: string;
      isFlexWorker: boolean;
      employmentType: WorkerEmploymentType | undefined;
    }
  ) => {
    const isFreelancerWithinCancelationPeriod = isWithinCancelationPeriod(shiftData, candidate);
    const dialogContent = getOgpCancelationDialog(isFreelancerWithinCancelationPeriod);
    openDialog(dialogContent, () => {
      disableDialog();
      cancelShiftClaim.mutate(
        {
          shiftClaimId: candidate.claimId,
          payload: {
            cancelationReason: null,
          },
        },
        {
          onSuccess: () => {
            invalidateQuery(QUERY_KEYS.shifts());
            invalidateQuery(QUERY_KEYS.shift(shiftData.id));
            closeDialog();
            alertSuccess(shiftAlerts.success.unsubscribed);
          },
          onError: (e) => alertError(e),
          onSettled: () => {
            enableDialog();
          },
        }
      );
    });
  };

  return (
    <ContextMenuItem
      onClick={() => handleCancelShiftClaim(shiftData, candidate)}
      key={`cancel-claim-${candidate.claimId}`}
    >
      <IconCloseCircle />
      Annuleren als opdrachtgever
    </ContextMenuItem>
  );
};
